import React from 'react';
import './styles.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-names">Aurel <span>&</span> Dennys</div>
      <div className="footer-date">31 · X · 2026</div>
    </footer>
  );
}

export default Footer;
